import React from "react";
import { PrintRecord } from "../../../BlakeData/Types";
import Micropalette from "../../../Micropalette";
import { API } from "../../../BlakeData";

export default function ViewerMicropalette(props: {
    prints: Array<PrintRecord>;
    height: number;
    width: number;
    side: "left" | "right" | "bottom" | "top";
}) {
    const palettes = API.makeSwatchArray(props.prints);

    return (
        <div className={`ViewerMicropalette ${props.side}`}>
            <Micropalette
                height={props.height}
                paletteWidth={props.width}
                padding={0}
                id={`viewer-micropalette`}
                palettes={palettes}
                vertical={(props.side !== "left") && (props.side !== "right")}
                // vertical={true}
                proportional={false}
            />
        </div>
    )

}
